import { PerforationEnum } from "../../enum";

export class MaterialTypeDto {
    materialType: string;
    advancePayment: PerforationEnum;

  
    constructor(materialType: string,advancePayment: PerforationEnum) {
        this.materialType = materialType
        this.advancePayment = advancePayment

    }

}